import { GOOGLE_AUTH2_API } from './types';

const initialState = {
  auth2Ready: false,
};

const google = (state = initialState, action) => {
  switch (action.type) {
    case GOOGLE_AUTH2_API.INIT_SUCCESS:
      return {
        ...state,
        auth2Ready: true,
      };
    default:
      return state;
  }
};

export default google;
